var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82.1755 104.113C74.8721 108.112 66.7627 110.417 58.4479 110.857C50.133 111.297 41.8256 109.861 34.1409 106.655C26.4562 103.45 19.5911 98.5563 14.0539 92.3377C8.51675 86.1191 4.44937 78.7346 2.15298 70.731C-0.143413 62.7274 -0.609978 54.3098 0.787835 46.1014C2.18565 37.8931 5.41203 30.1043 10.2281 23.3119C15.0441 16.5195 21.3264 10.8975 28.6097 6.86211C35.893 2.82677 43.9908 0.48151 52.3034 0C42.5181 1.36147 33.3325 5.51432 25.8463 11.9613C18.3602 18.4084 12.8908 26.8764 10.0929 36.3515C7.29508 45.8266 7.28731 55.9074 10.0706 65.3868C12.8539 74.8663 18.3102 83.3427 25.7864 89.8012C33.2626 96.2598 42.4418 100.427 52.225 101.803C62.0082 103.18 71.9809 101.708 80.949 97.5628C89.9171 93.418 97.5007 86.7764 102.792 78.433C108.083 70.0897 110.857 60.3982 110.782 50.5189C111.737 61.2656 109.539 72.0575 104.459 81.5755C99.3787 91.0934 91.6353 98.925 82.1755 104.113Z",
    fill: "#84E2D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector14);
export default __webpack_public_path__ + "static/media/vector-14.591352b35789f0296c2f0541603a7bed.svg";
export { ForwardRef as ReactComponent };